import "./style.less";

export default function HeroDesktop() {
    return {
        restrict: "E",
        scope: {},
        template: require("./template.html"),

        controller: function ($scope, $rootScope, $route, $window) {
            $scope.isActive = false;

            // decide whether its active
            // on-load
            // on resize
            // on route change

            whenHeroIsActive($route.current.$$route.hasHeroDesktop);

            var routeChangeStartEventListener = $rootScope.$on(
                "$routeChangeStart",
                function (event, currentRoute) {
                    whenHeroIsActive(currentRoute.hasHeroDesktop);
                }
            );
            $scope.$on("$destroy", routeChangeStartEventListener);

            angular.element($window).bind("resize", function () {
                whenHeroIsActive($route.current.$$route.hasHeroDesktop);

                // manuall $digest required as resize event
                // is outside of angular
                $scope.$digest();
            });

            function whenHeroIsActive(isActive) {
                if (isActive) {
                    $scope.isActive = true;
                } else {
                    $scope.isActive = false;
                }
            }
        },
    };
}
